import React, { useState } from 'react';
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  DateField,
  EditButton,
  ShowButton,
} from 'react-admin';
import { AmplifyPagination } from '../../ra-aws-amplify';
import ListActions from './ListActions';

export default (props) => {
  const [filter, setFilter] = useState(null);

  return (
    <List
      {...props}
      actions={<ListActions showCreate={false} />}
      pagination={<AmplifyPagination onNext={(filter) => setFilter(filter)} />}
      filter={filter}
      perPage={100}
    >
      <Datagrid rowClick="show">
        <TextField disabled label="Id" source="id" />
        <ReferenceField label="Fb Page" source="fbPageId" reference="FbPage">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="name" />
        <TextField source="description" />
        <TextField source="country" />
        <TextField source="live" />
        <DateField source="datePublished" showTime />
        <EditButton />
        <ShowButton />
      </Datagrid>
    </List>
  );
};
